import React from 'react';
import backgroundImg from '../img/bg_4.jpg'; // Укажите ваш путь

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <p>&copy; 2020 Эволюция стиля</p>
        <nav className="footer-nav">
          <a href="/">Главная</a>
          <a href="/history">История конкурса</a>
          <a href="/nominations">Номинации</a>
          <a href="/regulations">Положение</a>
          <a href="/gallery">Галерея</a>
          <a href="/contacts">Контакты</a>
        </nav>
      </div>
      <div
        className="footer-bottom"
        style={{ backgroundImage: `url(${backgroundImg})` }}
      > 
        <p>Пользовательское соглашение</p>
        <p>Программа фестиваля</p>
        <p>2019-2024 &copy; "Эволюция стиля"</p>
      </div>
    </footer>
  );
};

export default Footer;
